import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import { validations } from "../../utility/constants/errors/messages";
import utilities from "../../utility/utilities";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";

const VendorInfo = ({
  selectedServices,
  setSelectedServices,
  setSelectedClasses,
  selectedClasses,
  setVendorCode,
  setStatus,
  setCompanyType,
  setEffectiveDate,
  setCategory,
  setGroup,
  setPreference,
  setErrors,
  setErrorMessages,
  setVendorName,
  preference,
  errors,
  errorMessages,
  vendorCode,
  vendorName,
  status,
  companyType,
  effectiveDate,
  category,
  group,
  isView,
  statusOptions,
  companyTypeOptions,
  categoryOptions,
  groupOptions,
  preferenceOptions,
  setIsChanged,
  isEdit,
  handleDescClear,
  clearField,
  setClearField,
  vendorOptions = [],
  setDeafault
}) => {
  const serviceOptions = [
    { label: "BEMS", value: "BEMS", id: 1 },
    { label: "FEMS-Mec", value: "FEMS-Mec", id: 2 },
    { label: "FEMS-Elec", value: "FEMS-Elec", id: 3 },
    { label: "FEMS-Civil", value: "FEMS-Civil", id: 4 },
  ];

  const classOptions1 = [
    {
      label: "Consumable and parts supplier",
      value: "Consumable and parts supplier",
      id: 1,
    },
    { label: "Office Supplier", value: "Office Supplier", id: 2 },
    {
      label: "General Supllier and Services",
      value: "General Supllier and Services",
      id: 3,
    },
    { label: "Non-Solo Agent", value: "Non-Solo Agent", id: 4 },
  ];

  const classOptions2 = [
    { label: "Contractor", value: "Contractor", id: 5 },
    { label: "Consultant", value: "Consultant", id: 6 },
    {
      label: "Personal Productive Equipment",
      value: "Personal Productive Equipment",
      id: 7,
    },
    { label: "Solo Agent", value: "Solo Agent", id: 8 },
  ];
  const statusRef = useRef(null);
  useEffect(() => {
    if (isEdit) {
      statusRef.current.focus();
    }
  }, [isEdit]);

  const handleServiceChange = (event) => {
    setIsChanged(true);
    const { value, checked } = event.target;
    if (checked) {
      setErrors((prev) => ({ ...prev, services: false }));
      setErrorMessages((prev) => ({ ...prev, services: "" }));
    }
    setSelectedServices((prev) =>
      checked ? [...prev, value] : prev.filter((service) => service !== value)
    );
  };

  const handleClassChange = (event) => {
    setIsChanged(true);
    const { value, checked } = event.target;
    if (checked) {
      setErrors((prev) => ({ ...prev, classes: false }));
      setErrorMessages((prev) => ({ ...prev, classes: "" }));
    }
    setSelectedClasses((prev) =>
      checked ? [...prev, value] : prev.filter((vclass) => vclass !== value)
    );
  };

  const handleVendorNameChange = (newvalue) => {
    setIsChanged(true);
    setVendorName(newvalue);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, vendorName: false }));
      setErrorMessages((prev) => ({ ...prev, vendorName: "" }));
    }
    if (utilities.validateTextField(newvalue) || !newvalue) {
      setErrors((prev) => ({ ...prev, vendorName: false }));
      setErrorMessages((prev) => ({ ...prev, vendorName: "" }));
    } else if (!utilities.validateTextField(newvalue)) {
      setErrors((prev) => ({ ...prev, vendorName: true }));
      setErrorMessages((prev) => ({
        ...prev,
        vendorName: validations.textfield,
      }));
    }
  };

  const handleStatusChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, status: false }));
      setErrorMessages((prev) => ({ ...prev, status: "" }));
    }
    setStatus(newvalue);
  };

  const handleCompanyTypeChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, companytype: false }));
      setErrorMessages((prev) => ({ ...prev, companytype: "" }));
    }
    setCompanyType(newvalue);
  };

  const handleCategoryChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, category: false }));
      setErrorMessages((prev) => ({ ...prev, category: "" }));
    }
    setCategory(newvalue);
  };

  const handleGroupChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, group: false }));
      setErrorMessages((prev) => ({ ...prev, group: "" }));
    }
    setGroup(newvalue);
  };

  const handlePreferenceChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, preference: false }));
      setErrorMessages((prev) => ({ ...prev, preference: "" }));
    }
    setPreference(newvalue);
  };

  const handleEffectiveDateChange = (newvalue) => {
    setIsChanged(true);
    if (newvalue) {
      setErrors((prev) => ({ ...prev, effectiveDate: false }));
      setErrorMessages((prev) => ({ ...prev, effectiveDate: "" }));
    }
    setEffectiveDate(newvalue);
  };

  const handleVendorCodeChange = (newvalue) => {
    if (newvalue.label == "") {
      setDeafault();
    }
    else {
      setVendorCode({ ...newvalue, label: newvalue.value });
      setVendorName(newvalue.firstName);
      setErrors((prev) => ({ ...prev, vendorCode: false }));
      setErrorMessages((prev) => ({ ...prev, vendorCode: "" }));
    }
  };


  return (
    <>
      <Grid item xs={6} md={4}>
        <CustomTextFieldWithSearch
          label="Vendor Code"
          value={vendorCode}
          onChange={handleVendorCodeChange}
          isMandatoryField={true}
          disabled={isView || isEdit}
          error={errors.vendorCode}
          helperText={errorMessages.vendorCode}
          options={vendorOptions}
          onClear={handleDescClear}
          clearField={clearField}
          setClearField={setClearField}
          autoFocus={true}
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <CustomTextField
          label={"Vendor Name"}
          value={vendorName}
          onChange={handleVendorNameChange}
          maxlength={60}
          disabled={true}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <CustomSelectInput
          label={"Status"}
          onChange={handleStatusChange}
          options={statusOptions}
          error={errors.status}
          helperText={errorMessages.status}
          value={status}
          isMandatoryField={true}
          disabled={isView}
          inputRef={statusRef}
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <CustomSelectInput
          label={"Type of Company"}
          isMandatoryField={true}
          options={companyTypeOptions}
          error={errors.companytype}
          helperText={errorMessages.companytype}
          onChange={handleCompanyTypeChange}
          value={companyType}
          disabled={isView}
        />
      </Grid>

      <Grid item xs={6} md={4}>
        <CustomDatePicker
          label={"Effective Date"}
          isMandatoryField={true}
          error={errors.effectiveDate}
          helperText={errorMessages.effectiveDate}
          onDateChange={handleEffectiveDateChange}
          value={effectiveDate}
          disabled={isView}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <CustomSelectInput
          label={"Category"}
          value={category}
          options={categoryOptions}
          onChange={handleCategoryChange}
          error={errors.category}
          helperText={errorMessages.category}
          isMandatoryField={true}
          disabled={isView}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <CustomSelectInput
          label={"Group"}
          value={group}
          options={groupOptions}
          error={errors.group}
          helperText={errorMessages.group}
          onChange={handleGroupChange}
          isMandatoryField={true}
          disabled={isView}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <CustomSelectInput
          label={"Preference"}
          value={preference}
          error={errors.preference}
          helperText={errorMessages.preference}
          options={preferenceOptions}
          onChange={handlePreferenceChange}
          isMandatoryField={true}
          disabled={isView}
        />
      </Grid>
      <Grid item xs={6} md={4}>
        <FormControl fullWidth error={true}>
          <Box>
            <Typography variant="labelSm">Service</Typography>
            <Typography component={"span"} color={"error"}>
              *
            </Typography>
          </Box>
          {errors.services && (
            <FormHelperText sx={{ marginLeft: "0px" }}>
              {errorMessages.services}
            </FormHelperText>
          )}
          <FormGroup row sx={{ justifyContent: "space-between" }}>
            {serviceOptions.map((service) => (
              <FormControlLabel
                key={service.value}
                control={
                  <Checkbox
                    error={true}
                    checked={selectedServices.includes(service.value)}
                    onChange={handleServiceChange}
                    value={service.value}
                    disabled={isView}
                  />
                }
                label={service.label}
              />
            ))}
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid item xs={6} md={4}>
        <FormControl fullWidth error={true}>
          <Box>
            <Typography variant="labelSm">Class</Typography>
            <Typography component={"span"} color={"error"}>
              *
            </Typography>
          </Box>
          {errors.classes && (
            <FormHelperText sx={{ marginLeft: "0px" }}>
              {errorMessages.classes}
            </FormHelperText>
          )}
          <FormGroup row sx={{ justifyContent: "space-between" }}>
            {classOptions1.map((service) => (
              <FormControlLabel
                key={service.value}
                control={
                  <Checkbox
                    error={true}
                    checked={selectedClasses.includes(service.value)}
                    onChange={handleClassChange}
                    value={service.value}
                    disabled={isView}
                  />
                }
                label={service.label}
              />
            ))}
          </FormGroup>
        </FormControl>
      </Grid>
      <Grid item xs={6} md={4} sx={{ display: "flex" }}>
        <FormControl fullWidth error={true} sx={{ justifyContent: "end" }}>
          <FormGroup row sx={{ justifyContent: "space-between" }}>
            {classOptions2.map((service) => (
              <FormControlLabel
                key={service.value}
                control={
                  <Checkbox
                    error={true}
                    checked={selectedClasses.includes(service.value)}
                    onChange={handleClassChange}
                    value={service.value}
                    disabled={isView}
                  />
                }
                label={service.label}
              />
            ))}
          </FormGroup>
        </FormControl>
      </Grid>
    </>
  );
};

export default VendorInfo;
